"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  AM: {
    EN: 'AM',
    AR: 'صباحا'
  },
  PM: {
    EN: 'PM',
    AR: 'مساء'
  },
  HOURS: {
    EN: 'hours',
    AR: 'ساعات'
  }
};